export default __webpack_public_path__ + "static/media/Group9178.acaf440f.svg";